'use client';

import { useSession } from 'next-auth/react';
import { useEffect } from 'react';
import { recordAuthenticatedUserIp } from '@utils/ip-tracking';

export function AuthenticatedUserIpRecorder() {
  const { data, status } = useSession();

  useEffect(() => {
    if (status !== 'authenticated') {
      return;
    }

    const recordIpAddress = () => {
      recordAuthenticatedUserIp({
        accessToken: data?.user?.token?.accessToken,
        userId: data?.user?.id,
      }).catch((error) => {
        console.error('Failed to record authenticated user IP:', error);
      });
    };

    recordIpAddress();
    window.addEventListener('client-context-ready', recordIpAddress);

    return () => {
      window.removeEventListener('client-context-ready', recordIpAddress);
    };
  }, [data?.user?.id, data?.user?.token?.accessToken, status]);

  return null;
}
